/*!

=========================================================
* 　テンプレート
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";

import _ from 'underscore';

import { Link } from 'react-router-dom';
import InputText from '../FormParts/InputText';
import InputNumber from '../FormParts/InputNumber';
import InputSelect from '../FormParts/InputSelect';
import InputRadio from '../FormParts/InputRadio';
import GoogleMap from '../ViewParts/GoogleMap';
import Images from '../ViewParts/Images';
import SupplierSelectPopup from '../ViewParts/SupplierSelectPopup';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import Format from '../../common/Format';
import Request from '../../common/Request';
import Common from '../../common/Common';
import InputCheckBox from '../FormParts/InputCheckBox'
import {
  cst_prefecture,
  cst_pay_unit_type_day,
  cst_pay_unit_type_month,
  cst_commission_type,
  cst_landmark_available,
  cst_parking_parallel_type,
  cst_transshipment_flag,
  cst_oneday_flag
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import { getErrorCodes } from "../../variables/message";

const domain = "";

class Regist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title:"",
      valid: true,
      regist_modal: false,
      error_modal: false,
      supplier_id: "",
      data: {
        values:{
          capacity_flag_car:1,
          capacity_flag_light_truck:1,
          parking_pictures:[],
          parking_picture_url:"",
          parking_picture_url_thumbnail:"",
          pay_unit_type_day : cst_pay_unit_type_day[0].default,
          pay_unit_type_month : cst_pay_unit_type_month[0].default,
          commission_type : cst_commission_type[0].default,
          landmark_available : cst_landmark_available[0].default,
          parking_parallel_type : cst_parking_parallel_type[0].default,
          transshipment_flag : cst_transshipment_flag[0].default,
          oneday_flag : cst_oneday_flag[0].default,
          transshipment_flag : cst_transshipment_flag[0].default,
        },
        errors:{},
        requiredData:{}
      },
      supplier_data: {
      },
      view: false,
    };

    this.googlemap = React.createRef();
    this.images = React.createRef();
    this.supplier_select_popup = React.createRef();
    
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
    this.alertFromMap = this.alertFromMap.bind(this)
    this.supplierSelected = this.supplierSelected.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.handle_change_input_file = this.handle_change_input_file.bind(this)
    this.validate = this.validate.bind(this)
    this.regist = this.regist.bind(this)

    this.uploadImageCallback = this.uploadImageCallback.bind(this)
  }
  // life cycle method : before rendering 
  // static getDerivedStateFromProps(props, state){
    
  // }

  // 初期ロード用
  // life cycle method: after rendering
  componentDidMount(){
    if (this.props.match.params.ulid != undefined) {
      const url = domain + '/api/parking/' + this.props.match.params.ulid;
      Request.get(url, {},
        async res => {
          this.setState({
            data: {
              ...this.state.data,
              values:{
                ...res.data,
                parking_pictures: res.data.parking_picture_filelist?res.data.parking_picture_filelist.split(','):[]
              }
            },
            view: true
          }, ()=>{
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
          });
          var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
          var params = {};
          Request.get(url, params, res => {
            this.setState({
              data:{
                ...this.state.data,
                values:{
                  ...this.state.data.values,
                  lastupdate_user:res.Data
                }
              }
            });
          });

          Request.get(domain + `/api/supplier/${res.Data.supplier_ulid}`, {},
            res => {
              this.setState({
                data: {
                  ...this.state.data,
                  values:{
                    ...this.state.data.values,
                    supplier_ulid: res.Data.ulid,
                  }
                },
                supplier_data:{
                  ...res.Data.supplier,
                  supplier_bank:res.Data.supplier_bank
                }
              }, this.setRequiredData);
            });
        });
    } else {
      this.setRequiredData() 
    }
  }

  setRequiredData = async ()=>{
    const url = domain + '/api/parking';
    const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
    this.setState({
      data:requiredCheckedData
    })
  }
  
  validate() {
    const { supplier_natural_id } = this.state.supplier_data;
    let message = getErrorCodes(this.state.data.errors)
    
    if(!supplier_natural_id){
      message.push(2432)
    }

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }
  
  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;
    
    const parking_address_contract = (data.values.parking_city !== newData.values.parking_city)?
    (Common.getValueFormDictArray(cst_prefecture, newData.values.parking_prefecture) + newData.values.parking_city):
    newData.values.parking_address_contract

    this.setState({
      data:{
        ...data,
        ...newData,
        values:{
          ...newData.values,
          parking_address_contract
        }
      }
    }, ()=>callback())
  }

  handle_change_input_file(e) {
    if (e.target.files.length <= 0) {
      return;
    }
    let file = e.target.files[0];
    this.images.current.addImage(file);
  }

  supplierSelected(supplier) {
    if (supplier) {
      this.setState({
        data: {
          ...this.state.data,
          values:{
            ...this.state.data.values,
            supplier_ulid:supplier.ulid
          }
        },
        supplier_data: supplier 
      });
    }
  }

  updateLocation() {
    const {values} = this.state.data
    if (!values || !values.parking_prefecture) {
      return
    }
    this.googlemap.current.setAddress(Common.getValueFormDictArray(cst_prefecture, values.parking_prefecture) + values.parking_city + values.parking_address);
  }

  onLocationChange(latitude, longitude) {
    let data = this.state.data;
    // console.log(data);
    if (data.errors != undefined){
      delete data.errors.latitude;
      delete data.errors.longitude;
    }
    

    this.setState({ 
      data: {
        ...data,
        values:{
          ...data.values,
          latitude,
          longitude
        }
      }
    });
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  
  regist() {
    // 画像一覧は非同期で画像が追加されるので登録の直前で取り出す
    if (!this.validate()) {
      this.props.alertModal.current.showErrorModal({messageNo:2401})
      return
    }
    const parking_picture_url_thumbnail = this.state.data.values.parking_pictures.length>0
    ? (this.state.data.values.parking_picture_url_thumbnail 
      ? this.state.data.values.parking_picture_url_thumbnail 
      : this.state.data.values.parking_pictures[0]
      )
    : ""
    const params = {
      ...this.state.data.values,
      supplier_id : this.state.supplier_data.supplier_id,
      supplier_natural_id : this.state.supplier_data.supplier_natural_id,
      supplier_ulid:this.state.supplier_data.ulid,
      banned_flag:this.state.supplier_data.banned_flag,
      parking_picture_url_thumbnail
    };
    var url = domain + '/api/parking';
    if(this.state.view === false) {
      Request.post(url, params, res => {
        this.props.pageChangeAlert.current.inactivate();
        this.props.history.push('/parking');
      });
    } else {
      // 更新
      url = url + '/' + this.state.data.values.ulid;

      // 駐車場インポートデータがnullの場合の対策
      // 画面の情報を正とし、各車両制限：収容可能車種フラグに1:か0が必ず入るようにする
      params.capacity_flag_car = params.capacity_flag_car ? params.capacity_flag_car : 0;
      params.capacity_flag_light_truck = params.capacity_flag_light_truck ? params.capacity_flag_light_truck : 0;
      params.capacity_flag_truck = params.capacity_flag_truck ? params.capacity_flag_truck : 0;
      params.capacity_flag_other = params.capacity_flag_other ? params.capacity_flag_other : 0;
      
      Request.put(url, params, res => {
        this.props.pageChangeAlert.current.inactivate();
        this.props.history.push(`/parking/detail/${this.props.match.params.ulid}`) 
      });
    }
    
  }

  alertFromMap(messageNo){
    this.props.alertModal.current.showErrorModal({messageNo});
  }

  uploadImageCallback(imageIdList, imageFolderId, selectedId){
    this.setState({
      data:{
        ...this.state.data,
        values:{
          ...this.state.data.values,
          parking_pictures:imageIdList,
          parking_picture_url:imageFolderId,
          parking_picture_url_thumbnail:selectedId
        },
        
      }
    })
  }

  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";

    }

  }

  set_title() {
    if (this.state.view === false) {
      return "駐車場マスタ新規登録";
    }
    return "駐車場マスタ更新";
  }

  render() {
    console.log('state', this.state)
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{this.set_title()}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                  <SystemInfo
                    id_title='駐車場ID'
                    id_value={this.state.data.values.parking_natural_id}
                    update_timestamp={this.state.data.values.update_timestamp}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                    visible={this.state.view} />

                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label='メモ'
                          colSpan="4"
                          name='PARKING__system_memo'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText multiline={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='削除フラグ'
                          name='PARKING__delete_flag'
                          copy={false}
                          value={
                            <InputCheckBox 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='出入禁止フラグ'
                          name='PARKING__banned_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4">基本情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="3">駐車場情報</th> */}
                        <CustomTd label='駐車場名'
                          colSpan="4"
                          name='PARKING__parking_name'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              hasKanaInput={true}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='駐車場名（カナ）'
                          name='PARKING__parking_name_kana'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      {/* <tr>
                        <CustomTd label='駐車場名（正式名称）'
                          name='PARKING__parking_name_contract'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr> */}
                      <tr>
                        {/* <th rowSpan="4">所在地</th> */}
                        <CustomTd label='都道府県'
                          name='PARKING__parking_prefecture'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputSelect
                              options={cst_prefecture}
                              validateCallback={this.validateCallback}
                              rootData={this.state.data} 
                              isSearchable={true}
                              isNull={true}
                              validateType="regist" 
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='市区町村'
                          name='PARKING__parking_city'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                        <CustomTd label='番地（町名以降）'
                          name='PARKING__parking_address'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='土地の地番（契約書記載の所在地）'
                          name='PARKING__parking_address_contract'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="収容可能車種" 
                          colSpan="4"
                          copy={false}
                          value={
                          <>
                            <InputCheckBox label="ワゴン車"
                              name="ESTIMATE__capacity_flag_car" 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                              />
                            <InputCheckBox label="軽トラック"
                              name="ESTIMATE__capacity_flag_light_truck" 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                              />
                            <InputCheckBox label="2tトラック"
                              name="ESTIMATE__capacity_flag_truck" 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                              />
                            <InputCheckBox label="その他"
                              name="ESTIMATE__capacity_flag_other" 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                              />
                          </>
                        }/>
                      </tr>
                      <tr>
                        <CustomTd label='その他詳細'
                          name='PARKING__capacity_car_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='特別条件'
                          name='PARKING__capacity_special_request'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText multiline={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>

                  <CardTitle tag="h4">仕入情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="4">仕入</th> */}
                        <CustomTd label='賃料（月単価）'
                          name='PARKING__cost_parking_rent'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              unit='円'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='手数料'
                          name='PARKING__cost_commission'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              unit='円'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='敷金'
                          name='PARKING__cost_security_deposit'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              unit='円'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='礼金'
                          name='PARKING__cost_key_money'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              unit='円'
                            />
                          }
                        />
                      </tr>
                      {/* <tr>
                        <CustomTd label="調整額（単価）"
                          name="PARKING__cost_adjustment"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber 
                              validateCallback={this.validateCallBack} 
                              validateType="regist"
                              unit='円'
                               />
                            } />
                      </tr> */}
                      <tr>
                        {/* <th rowSpan="3">計算方法</th> */}
                        <CustomTd label='日割可否'
                          name='PARKING__pay_unit_type_day'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_pay_unit_type_day}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='通し可否'
                          name='PARKING__pay_unit_type_month'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_pay_unit_type_month}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='手数料計算方法'
                          name='PARKING__commission_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_commission_type}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>

                  <CardTitle tag="h4">駐車場の特徴</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="2">目印設置</th> */}
                        <CustomTd label='目印設置可否'
                          name='PARKING__landmark_available'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_landmark_available}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      {/* <tr>
                        <CustomTd label="敷地内か否か"
                          name="PARKING__parking_onsite_type"
                          copy={false}
                          rootData={this.state.data}
                          value={
                              <InputSelect 
                                options={cst_parking_onsite_type}
                                validateCallback={this.validateCallBack} 
                                />
                          } />
                      </tr> */}
                      {/* <tr>
                        <CustomTd label="草が生えているか"
                          name="PARKING__parking_grass_type"
                          copy={false}
                          rootData={this.state.data}
                          value={
                              <InputSelect 
                                options={cst_parking_grass_type}
                                validateCallback={this.validateCallBack} 
                                />
                          } />
                      </tr> */}
                      <tr>
                        <CustomTd label='駐車方法'
                          name='PARKING__parking_parallel_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_parking_parallel_type}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                       {/* <th rowSpan="2">絞込条件</th> */}
                        <CustomTd label="積替用として利用"
                          name="PARKING__transshipment_flag"
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio options={cst_transshipment_flag}
                              validateCallback={this.validateCallback} 
                              />
                          } />
                      </tr>
                      <tr>
                        <CustomTd label='単日での利用可否'
                          name='PARKING__oneday_flag'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_oneday_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4">写真・地図</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="3">写真・地図</th> */}
                        <td className="subTitle">写真</td>
                        <td colSpan="3" style={{ position: "relative" }}>
                          <Images
                          {...this.props}
                            ref={this.images}
                            editable={true}
                            name='PARKING__parking_picture_url'
                            rootData={this.state.data}
                            uploadCallback={this.uploadImageCallback}
                            image_items={this.state.data.values.parking_pictures || []}
                            imageFolderId={this.state.data.values.parking_picture_url}
                            defaultCheckedImage={this.state.data.values.parking_picture_url_thumbnail}
                            selectable={true}
                           />
                        </td>
                      </tr>
                      <tr>
                        <CustomTd label='緯度'
                          name='PARKING__latitude'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              disabled={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                        <CustomTd label='経度'
                          name='PARKING__longitude'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputNumber
                              disabled={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <td className="subTitle">地図</td>
                        <td colSpan="3">
                          <GoogleMap
                            ref={this.googlemap}
                            alertModal={this.alertFromMap}
                            center={{
                              latitude: this.state.data.values.latitude,
                              longitude: this.state.data.values.longitude
                            }}
                            aerial={false}
                            onLocationChange={this.onLocationChange}
                            editable={true}
                          />
                          <Button
                            style={{ float: 'right', marginTop: '5px' }} 
                            size="sm"
                            className="btn-dribbble btn-sm"
                            onClick={this.updateLocation}>
                            入力住所で検索
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  {/* <CardTitle tag="h4">契約情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr> */}
                        {/* <th>契約情報</th> */}
                        {/* <CustomTd label="契約書作成"
                          name="PARKING__contract_create_type"
                          copy={false}
                          rootData={this.state.data}
                          value={
                              <InputSelect 
                                options={contract_create_type}
                                validateCallback={this.validateCallBack} 
                                />
                          } />
                        <CustomTd label="契約締結"
                          name="PARKING__contract_visit_type"
                          copy={false}
                          rootData={this.state.data}
                          value={
                              <InputSelect 
                                options={contract_visit_type}
                                validateCallback={this.validateCallBack} 
                                />
                          } />
                      </tr>
                    </tbody>
                  </Table> */}
                  <span>
                    <CardTitle tag="h4" className="float-left">仕入先情報</CardTitle>
                    <Button className="float-right" size="sm" color="info" style={{ marginTop: "30px" }} onClick={() => { this.supplier_select_popup.current.show(); }}>仕入先マスタから選択</Button>
                  </span>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="4">仕入先</th> */}
                        <td className="subTitle">仕入先ID</td>
                        <td>
                          {
                            <Link className="link" target="_blank" to={"/supplier/detail/" + this.state.supplier_data.ulid}>{this.state.supplier_data.supplier_natural_id}</Link>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="subTitle">仕入先名</td>
                        <td>{this.state.supplier_data.supplier_name}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">仕入先名（カナ）</td>
                        <td>{this.state.supplier_data.supplier_name_kana}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">電話番号1</td>
                        <td>{Format.phone_number(this.state.supplier_data.supplier_tel)}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">電話番号2</td>
                        <td>{Format.phone_number(this.state.supplier_data.supplier_tel2)}</td>
                      </tr>
                    </tbody>
                  </Table>

                  <Row md="12">
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/parking') 
                        } else {
                          this.props.history.push(`/parking/detail/${this.props.match.params.ulid}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    
                    <Col md="6" className="text-center">
                      <ButtonWithRole 
                        button_id={this.state.view?"BTN_M3_04_04700":"BTN_M3_02_04540"}
                        color="info" 
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal();
                          }
                        }}
                      >
                        {this.button_name()}
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
        <SupplierSelectPopup {...this.props} view={this.state.view} ref={this.supplier_select_popup} supplierSelectedCallback={this.supplierSelected} />
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={() => { this.toggleRegistModal(); this.regist(); }}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default Regist;
